module.exports = __webpack_public_path__ + "static/frontpage-image-2-min-1ae430c330a480a9dd5bc2f933494e11.jpg";